import {Reducer} from "redux";
import {PledgerAction} from "@pledger/frontend-commons";
import {CreateSouscriptionActions} from "../CreateSouscriptionActions";
import {CreateSelfcareSouscriptionActions} from "./CreateSelfcareSouscriptionActions";


const warrantyPartnerId = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case CreateSouscriptionActions.SELECT_MODULE_TO_DISPLAY_ACTION.type:
            return '';

        case CreateSelfcareSouscriptionActions.CREATE_SELFCARE_SOUSCRIPTION_SELECT_WARRANTY_PARTNER_ACTION.type:
            return action.payload.warrantyPartnerId;
        default:
            return state;
    }
};

const accountTypeId = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case CreateSouscriptionActions.SELECT_MODULE_TO_DISPLAY_ACTION.type:
            return '';

        case CreateSelfcareSouscriptionActions.CREATE_SELFCARE_SOUSCRIPTION_SELECT_ACCOUNT_TYPE_ACTION.type:
            return action.payload.accountTypeId;
        default:
            return state;
    }
};

const accountNumber = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case CreateSouscriptionActions.SELECT_MODULE_TO_DISPLAY_ACTION.type:
            return '';

        case CreateSouscriptionActions.CHANGE_SELFCARE_ACCOUNT_NUMBER_ACTION.type:
            return action.payload.accountNumber;

        default:
            return state;
    }
};

const accountLabel = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case CreateSouscriptionActions.SELECT_MODULE_TO_DISPLAY_ACTION.type:
            return '';

        case CreateSouscriptionActions.CHANGE_SELFCARE_ACCOUNT_LABEL_ACTION.type:
            return action.payload.accountLabel;

        default:
            return state;
    }
};

const firstName = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case CreateSouscriptionActions.SELECT_MODULE_TO_DISPLAY_ACTION.type:
            return '';

        case CreateSouscriptionActions.CHANGE_SELFCARE_FIRSTNAME_ACTION.type:
            return action.payload.firstName;

        default:
            return state;
    }
};

const lastName = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case CreateSouscriptionActions.SELECT_MODULE_TO_DISPLAY_ACTION.type:
            return '';

        case CreateSouscriptionActions.CHANGE_SELFCARE_LASTNAME_ACTION.type:
            return action.payload.lastName;

        default:
            return state;
    }
};

const phoneNumber = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case CreateSouscriptionActions.SELECT_MODULE_TO_DISPLAY_ACTION.type:
            return '';

        case CreateSouscriptionActions.CHANGE_SELFCARE_PHONENUMBER_ACTION.type:
            return action.payload.phoneNumber;

        default:
            return state;
    }
};

const email = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case CreateSouscriptionActions.SELECT_MODULE_TO_DISPLAY_ACTION.type:
            return '';

        case CreateSouscriptionActions.CHANGE_SELFCARE_EMAIL_ACTION.type:
            return action.payload.email;

        default:
            return state;
    }
};

export interface SouscriptionSelfcareState {
    warrantyPartnerId : string;
    accountTypeId : string;
    accountNumber: string;
    accountLabel: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    email: string;
}


export const souscriptionSelfcareReducers : Reducer = (state={}, action)=>{
    return{
        warrantyPartnerId: warrantyPartnerId(state.warrantyPartnerId, action),
        accountTypeId: accountTypeId(state.accountTypeId, action),
        accountNumber: accountNumber(state.accountNumber, action),
        accountLabel: accountLabel(state.accountLabel, action),
        firstName: firstName(state.firstName, action),
        lastName: lastName(state.lastName, action),
        phoneNumber: phoneNumber(state.phoneNumber, action),
        email: email(state.email, action),
    }
}
